import { render, staticRenderFns } from "./ReloadTriggerEffect.vue?vue&type=template&id=addf30dc&"
import script from "./ReloadTriggerEffect.vue?vue&type=script&lang=ts&"
export * from "./ReloadTriggerEffect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports